import { County } from 'src/app/model/county';
import { Region } from 'src/app/model/region.model';
import { CoeSchoolEnrollment } from './coe-school-enrollment.model';
import { SchoolEnrollmentComments } from './school-enrollment-comments.model';
import { SchoolEnrollmentDetailsAsl } from './school-enrollment-details-asl.model';
import { School } from 'src/app/model/school.model';
import { PartyRelationships } from './../../party/model/party-relationships.model';
import { SchoolEnrollmentDetails } from './school-enrollment-details.model';
import { SchoolDistrict } from '../../../model/schoolDistrict.model';

export class SchoolEnrollment {
    ID: number;
    PARTY_RELATIONSHIPS_ID: number;
    CREATED_BY: string;
    CREATED_DATE: Date;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date;
    SCHOOL_DISTRICT: SchoolDistrict;
    SCHOOL_DISTRICTS: SchoolDistrict;
    SOURCE: string;
    INA_ID: number;
    COE_SCHOOL_ENROLLMENTS: CoeSchoolEnrollment;
    SCHOOL_ENROLLMENT_DETAILS: SchoolEnrollmentDetails[];
    PARTY_RELATIONSHIPS: PartyRelationships;
    SCHOOL: School;
    SCHOOL_ENROLLMENT_DETAILS_ASL: SchoolEnrollmentDetailsAsl;
    SCHOOL_ENROLLMENT_COMMENTS: SchoolEnrollmentComments;
    REGION: Region;
    COUNTy: County;
}
